import { ColumnDef } from '@tanstack/react-table';

import TableCellText from '@/components/atoms/TableCellText';
import { SgftTraining } from '@/types/SuricattaTrainingData';

export const SuricattaTrainingTableColumnsColumns: Array<
	ColumnDef<SgftTraining>
> = [
	{
		accessorKey: 'training',
		id: 'trainingType',
		header: 'Tipo de Treinamento',
		meta: {
			headerClassName: 'bg-gray-100 text-primary text-left px-2 w-36',
		},
		cell: ({ getValue }) => {
			const training = getValue<SgftTraining['training']>();
			const trainingType = training.trainingType;
			return (
				<div className="w-36 px-2">
					<TableCellText text={trainingType} />
				</div>
			);
		},

		enableSorting: false,
	},
	{
		accessorKey: 'training',
		id: 'training',
		header: 'Treinamento',
		meta: {
			headerClassName: 'bg-gray-100 text-primary text-left px-2 w-[50rem]',
		},
		cell: ({ getValue }) => {
			const training = getValue<SgftTraining['training']>();
			const trainingName = training.name;
			return (
				<div className="w-[50rem]  overflow-hidden text-ellipsis px-2">
					<TableCellText
						text={trainingName}
						className="w-[50rem] overflow-hidden"
					/>
				</div>
			);
		},

		enableSorting: false,
	},
];
